import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef, useState } from "react";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import Authentication from "../../../libs/api/services/Authentication";
import CommonFunctionsContext from "../../common/CommonFunctionsProvider";
import ForgotPassword from "./ForgotPassword";

export default function LoginUser({ expired, exists }) {
  const { setAssistantSection, GlobalRef } = useContext(CommonFunctionsContext);
  const [showPW, setShowPW] = useState(false);
  const [details, setDetails] = useState({});
  const [error, setError] = useState("");
  const [processing, setProcessing] = useState(false);
  const [mode, setMode] = useState("Login");
  const usernameRef = useRef();

  useEffect(() => {
    setAssistantSection("Authentication");
    return () => setAssistantSection();
  }, []);

  const _handleLogin = async () => {
    if (!processing) {
      setProcessing(true);
      await Authentication.login(details)
        .then((r) => {
          setProcessing(false);
        })
        .catch((e) => {
          setError(e.message);
          if (e.message === "Temporary Password") {
            setMode("Temporary Password");
          }
          setProcessing(false);
        });
    }
  };
  const _handleReset = async () => {
    setMode("SendReset");
    if (!processing) {
      setProcessing(true);
      await Authentication.ResetPasswordRequest(usernameRef.current.value)
        .then((r) => {
          setProcessing(false);
        })
        .catch((e) => {
          setError(e.message);
          setProcessing(false);
        });
    }
  };
  const _handleResetTemp = async () => {
    // setMode('SendReset')
    if (!processing) {
      setProcessing(true);
      await Authentication.ResetPasswordTempRequest(details)
        .then(async (r) => {
          await Authentication.login(details).then((r) => {
            setProcessing(false);
          });
        })
        .catch((e) => {
          setError(e.message);
          setProcessing(false);
        });
    }
  };

  const _handleKeyDown = (e) => {

    if (e.key === "Enter") {
      if (mode === "ForgotPW") {
        _handleReset();
      } else {
        _handleLogin();
      }
    }
  };

  // if(mode === 'SendReset')
  // return(<div>
  // <p>An email will be sent to you shortly with further details to reset your password</p>
  // </div>)
  return (
    <div onKeyDown={(e) => _handleKeyDown(e)} className="Wizard center-all">
      <div className="head">
        <h1>
          {exists && <div>You have been registered.</div>}
          {expired ? <div>Your session has expired</div> : !exists && <div>Login</div>}
        </h1>
        {exists && <div>Please login to continue.</div>}
        {mode === "SendReset" && !error && !processing && (
          <p>
            An email will be sent to you shortly with further details to reset
            your password
          </p>
        )}
        {/* <p>If you have already been registered on system please login below</p> */}
        <div className="error-details">{error}</div>
      </div>
      <div className="body">
        <div className=".section undefined">
          {mode !== "SendReset" && (
            <div className="col-12">
              <div
                ref={(r) => GlobalRef(r, "LoginScreenUserID")}
                // ref={helpRefs.current['LoginScreenUserID'] ??= { current: null }}
                className="validation-container"
              >
                <label>User ID</label>
                <input
                  ref={usernameRef}
                  onFocus={() => {
                    const pw = document.querySelector('[data-login-password]');
                    if (pw) pw.scrollIntoView({ behavior: "smooth", block: "center" });
                  }}
                  onChange={(e) =>
                    setDetails({ ...details, IDNumber: e.target.value })
                  }
                  className="wizard-input form-control"
                  placeholder="ID Number"
                />
                <div className="validation-details"></div>
              </div>
            </div>
          )}
          {mode === "Login" && mode !== "SendReset" ? (
            <div className="col-12">
              <div
                ref={(r) => GlobalRef(r, "LoginScreenPassword")}
                className="validation-container"
              >
                <label>Password</label>
                <div className="d-flex position-relative">
                  <input
                    data-login-password
                    onFocus={() => {
                      const pw = document.querySelector('[data-login-button]');
                      if (pw) pw.scrollIntoView({ behavior: "smooth", block: "center" });
                    }}
                    onChange={(e) =>
                      setDetails({ ...details, password: e.target.value })
                    }
                    type={showPW ? "text" : "password"}
                    className="wizard-input form-control"
                    placeholder="Password"
                  />
                  <button
                    data-login-button
                    ref={(r) => GlobalRef(r, "LoginScreenShowPassword")}
                    className="btn position-absolute"
                    style={{ zIndex: 2, right: "0px" }}
                    onClick={() => setShowPW(!showPW)}
                  >
                    {showPW ? <EyeSlashFill /> : <EyeFill />}
                  </button>
                </div>
                {mode !== "SendReset" && (
                  <button disabled={processing} onClick={_handleLogin} className="btn bg-secondary-btn m-2">Log On</button>
                )}
                <div className="validation-details"></div>
              </div>
            </div>
          ) : (
            <></>
          )}

          {mode === "Temporary Password" && (
            <div className="col-12">
              <p>You have logged in with a temporary password</p>
              <p>Please enter a new secure password</p>
              <div
                ref={(r) => GlobalRef(r, "LoginScreenPassword")}
                className="validation-container"
              >
                <label>Password</label>
                <div className="d-flex position-relative">
                  <input
                    onChange={(e) =>
                      setDetails({ ...details, password: e.target.value })
                    }
                    type={showPW ? "text" : "password"}
                    className="wizard-input form-control"
                    placeholder="Password"
                  />
                  <button
                    ref={(r) => GlobalRef(r, "LoginScreenShowPassword")}
                    className="btn position-absolute"
                    style={{ zIndex: 2, right: "0px" }}
                    onClick={() => setShowPW(!showPW)}
                  >
                    {showPW ? <EyeSlashFill /> : <EyeFill />}
                  </button>
                </div>
                <div className="validation-details"></div>
              </div>
            </div>
          )}


          <div
            ref={(r) => GlobalRef(r, "LoginScreenForgotPassword")}
            className="col-12"
          >
            <ForgotPassword mode={mode} setMode={setMode} processing={processing} />
            {mode === "ForgotPW" && (
              !processing && <button onClick={_handleReset}>Next</button>
            )}

          </div>

          {/* <div className="col-12">
          <div className="validation-container">
            <label>Alternative Login</label>
            <input
              className="wizard-input form-control"
              placeholder="Alternative Login" />
            <div className="validation-details">

            </div>
          </div>
        </div> */}
          <div className="navigation">
            <div className="validation-container">
              <div className="validation-details"></div>
            </div>
          </div>
          <a
            ref={(r) => GlobalRef(r, "LoginTnCLink")}
            className="text-light"
            target="_blank"
            href="/tnc"
          >
            DrData Ts & Cs
          </a>
        </div>
      </div>
      <div className="tail">
        {processing ? (
          <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
          <>
            {mode === "ForgotPW" && (
              <button
                onClick={(e) => setMode("Login")}
                className="btn bg-secondary-btn"
              >
                Cancel
              </button>
            )}
            {mode === "SendReset" && (
              <button
                onClick={(e) => {
                  setMode("Login");
                  setError();
                }}
                className="btn bg-secondary-btn"
              >
                Ok
              </button>
            )}

            <a href="/signup" className="btn bg-secondary-btn text-white">
              Sign Up{" "}
            </a>
          </>
        )}
      </div>
    </div>
  );
}
